import { render, staticRenderFns } from "./talentTraining.vue?vue&type=template&id=26b58498&scoped=true&"
import script from "./talentTraining.vue?vue&type=script&lang=js&"
export * from "./talentTraining.vue?vue&type=script&lang=js&"
import style0 from "./talentTraining.vue?vue&type=style&index=0&id=26b58498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b58498",
  null
  
)

export default component.exports